import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styles from '../../styles/AdminPanel.module.scss';

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'list', 'bullet', 'indent',
  'align',
  'link', 'image',
  'blockquote', 'code-block',
];

const RichTextEditor = ({ value, onChange, placeholder, editorKey }) => {
  const quillRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ align: [] }],
        ['link', 'image', 'blockquote', 'code-block'],
        ['clean'],
      ],
    }),
    []
  );

  if (!mounted) {
    return (
      <div className={styles.quillWrapper}>
        <div className={styles.quillLoading}>Завантаження редактора…</div>
      </div>
    );
  }

  return (
    <div className={styles.quillWrapper}>
      <ReactQuill
        key={editorKey ?? 'product-description'}
        ref={quillRef}
        theme="snow"
        value={value || ''}
        onChange={(content) => onChange(content === '<p><br></p>' ? '' : content)}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};

export default RichTextEditor;
